function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import isEqual from 'lodash/isEqual';
import sortBy from 'lodash/sortBy';
import pick from 'lodash/pick';
import lazyGettext from 'js-utils/lazy-gettext';
import { REQUIRED_CROP_CANCELED, API_RESPONSE_BAD_FORMAT } from './constants';
import { getScrollAncestor } from 'js-utils/dom';
var GENERIC_UPLOAD_ERROR = lazyGettext('An error occurred, unable to upload at this time.');

var getCropMaskCoords = function getCropMaskCoords(cropMask) {
  var cropMaskCoords = cropMask['top_left'] || {};
  var x = cropMaskCoords.x || cropMaskCoords.x === 0 ? cropMaskCoords.x : '';
  var y = cropMaskCoords.y || cropMaskCoords.y === 0 ? cropMaskCoords.y : '';
  return {
    x: x,
    y: y
  };
};

export var transformApiImageToImageField = function transformApiImageToImageField(fieldName, apiImage) {
  var _ref;

  var imageObject = apiImage || {};
  var originalInfo = imageObject.original || {};
  var cropMask = imageObject['crop_mask'] || {};

  var _getCropMaskCoords = getCropMaskCoords(cropMask),
      x = _getCropMaskCoords.x,
      y = _getCropMaskCoords.y;

  return _ref = {}, _defineProperty(_ref, fieldName, imageObject.id || ''), _defineProperty(_ref, "".concat(fieldName, "Url"), imageObject.url || ''), _defineProperty(_ref, "".concat(fieldName, "OriginalUrl"), originalInfo.url || ''), _defineProperty(_ref, "".concat(fieldName, "CropX"), x), _defineProperty(_ref, "".concat(fieldName, "CropY"), y), _defineProperty(_ref, "".concat(fieldName, "CropWidth"), cropMask.width || ''), _defineProperty(_ref, "".concat(fieldName, "CropHeight"), cropMask.height || ''), _ref;
};
export var transformUploadFailureMessage = function transformUploadFailureMessage(result) {
  if (result === REQUIRED_CROP_CANCELED) {
    return Promise.reject('');
  }

  if (result && result.json) {
    return result.json().then(function (_ref2) {
      var error = _ref2.error;

      if (error === API_RESPONSE_BAD_FORMAT) {
        return Promise.reject(lazyGettext('There is a problem with this image format. Please verify the image is the type you expect or choose a different image.'));
      }

      return Promise.reject(GENERIC_UPLOAD_ERROR);
    });
  }

  return Promise.reject(GENERIC_UPLOAD_ERROR);
};
export var calculateWidthToPreventAncestorScroll = function calculateWidthToPreventAncestorScroll(node) {
  var minHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;
  var scrollAncestor = getScrollAncestor(node);

  if (!scrollAncestor) {
    return null;
  }

  var newWidth;
  var nodeWidth = node.clientWidth,
      nodeHeight = node.clientHeight;
  var scrollableHeight = scrollAncestor.clientHeight,
      scrollHeight = scrollAncestor.scrollHeight;
  var overflowAmount = scrollHeight - scrollableHeight;

  if (overflowAmount > 0) {
    var newHeight = Math.max(nodeHeight - overflowAmount, minHeight);
    newWidth = Math.floor(nodeWidth * newHeight / nodeHeight);
  }

  return newWidth;
}; // my initial need requires only one prop to deep compare.
// this could be updated to accept an array of props to deep compare,
// but it will hurt performance as it will require another loop to
// check the contents of the array.

export var conditionalDeepCompare = function conditionalDeepCompare(objectA, objectB, deepProp) {
  var objectAKeys = sortBy(Object.keys(objectA));
  var hasSameKeys = isEqual(objectAKeys, sortBy(Object.keys(objectB)));

  if (!hasSameKeys) {
    return false;
  }

  return objectAKeys.every(function (key) {
    var comparator = deepProp && key === deepProp ? isEqual : function (a, b) {
      return a === b;
    };
    return comparator(objectA[key], objectB[key]);
  });
};
export var pickPropsByTypes = function pickPropsByTypes(props, propTypes) {
  return pick.apply(void 0, [props].concat(_toConsumableArray(Object.keys(propTypes))));
};